var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lecture
    ? _c("Card", { staticClass: "video-lecture-item clickable" }, [
        _c("div", {
          staticClass: "video-lecture-item__thumbnail",
          style: _vm.lectureThumbStyle
        }),
        _vm._v(" "),
        _c("div", { staticClass: "card-block video-lecture-item__meta" }, [
          _c(
            "div",
            {
              staticClass:
                "card-title video-lecture-item__title typography--body-1",
              attrs: { title: _vm.lecture.title }
            },
            [_vm._v("\n      " + _vm._s(_vm.lecture.title) + "\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card-text" }, [
            _c("div", [
              _c(
                "small",
                {
                  staticClass:
                    "text-muted typography--caption typography--color-secondary"
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.getGradeLabel(_vm.lecture)) +
                      "\n          " +
                      _vm._s(_vm.getSubjectLabel(_vm.lecture)) +
                      "\n          "
                  ),
                  _vm.lecture.domain
                    ? _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.lecture.domain.name) +
                            "\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-3" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.getShareLevelLabel(_vm.lecture.share_level || 2)
                        ) +
                        "\n          "
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "small",
                {
                  staticClass:
                    "text-muted typography--caption typography--color-secondary"
                },
                [
                  _c("span", { staticClass: "mr-3" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.terms.view_count")) +
                        " " +
                        _vm._s(_vm.lecture.view_count) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "mr-3" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.terms.like")) +
                        " " +
                        _vm._s(_vm.lecture.like_count) +
                        "\n          "
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-518c2c2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-518c2c2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/video-lectures/components/VideoLectureItem.vue
// module id = 2IbC
// module chunks = 1